import { classImplementsInterfaces } from "@goodgamestudios/createjs-utilities";
import { VisualVO } from "./VisualVO";

export class CreateTablesVO extends VisualVO {
    public name: string;
    public help: boolean = false;
    public sBlind: number = NaN;
    public bBlind: number = NaN;
    public actionTime: number = 0;
    public fOnly: boolean = false;
}
classImplementsInterfaces(CreateTablesVO, "IInventoryVO");
